"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOP_MARGIN = exports.DIALOG_SIZES = void 0;
const DIALOG_SIZES = ["extra-small", "small", "medium-small", "medium", "medium-large", "large", "extra-large"];
exports.DIALOG_SIZES = DIALOG_SIZES;
const TOP_MARGIN = 20;
exports.TOP_MARGIN = TOP_MARGIN;